/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import Tabs from 'builder/components/Tabs'
import { ConnectorLine, TabItem, TabsContainer } from './styles'

type ContextProps = {
  activeTab: CategoryIds
  setActiveTab: (tab: CategoryIds) => void
}

const Context = React.createContext({} as ContextProps)

export type CategoryIds = 'resumes' | 'jobs' | 'interviews' | 'careers'
export const DEFAULT_ACTIVE_TAB: CategoryIds = 'resumes'

export default function CategoryTabs(props: {
  children: React.ReactNode
  defaultActive?: CategoryIds
}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const urlTab = searchParams.get('categoryTab') as CategoryIds | null

  const initialTab = urlTab ?? props.defaultActive ?? DEFAULT_ACTIVE_TAB
  const [activeTab, setActiveTab] = React.useState<CategoryIds>(initialTab)

  useEffect(() => {
    const next = new URLSearchParams(searchParams)
    next.set('categoryTab', activeTab)
    setSearchParams(next)
  }, [activeTab, searchParams])

  return <Context.Provider value={{ activeTab, setActiveTab }}>{props.children}</Context.Provider>
}

const List = ({ children }: { children: React.ReactNode }) => {
  const { activeTab } = React.useContext(Context)
  const childArray = React.Children.toArray(children)
  const activeIndex = childArray.findIndex(child => {
    return React.isValidElement(child) && child.props.id === activeTab
  })

  const itemsWithLines = childArray.flatMap((child, index) => {
    const showLine = index < childArray.length - 1
    const isLineActive = index === activeIndex || index === activeIndex - 1

    return showLine
      ? [child, <ConnectorLine key={`line-${index}`} isActive={isLineActive} />]
      : [child]
  })

  // @ts-ignore
  return <Tabs Container={TabsContainer}>{itemsWithLines}</Tabs>
}

const Item = (props: { children: React.ReactNode; tabId: CategoryIds }) => {
  const { activeTab, setActiveTab } = React.useContext(Context)

  return (
    <TabItem isActive={activeTab === props.tabId} onClick={() => setActiveTab(props.tabId)}>
      {props.children}
    </TabItem>
  )
}

const Content = (props: { children: React.ReactNode; tabId: CategoryIds }) => {
  const { activeTab } = React.useContext(Context)

  if (activeTab !== props.tabId) return null

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
      id={`${props.tabId}-content`}
    >
      {props.children}
    </div>
  )
}

CategoryTabs.List = React.memo(List)
CategoryTabs.Item = React.memo(Item)
CategoryTabs.Content = React.memo(Content)
